export let UnreadNum = {
  chat_rooms: {
    liked: "0",
    matched: "0",
    contacted: "0",
  },
  activity: "0",
  notice: "0",
  appointments: {
    future: "0",
  },

  set(data: {
    chat_rooms: {
      liked: string;
      matched: string;
      contacted: string;
    };
    activity: string;
    notice: string;
    appointments: {
      future: string;
    };
  }): void {
    this.chat_rooms.liked = data.chat_rooms.liked;
    this.chat_rooms.matched = data.chat_rooms.matched;
    this.chat_rooms.contacted = data.chat_rooms.contacted;
    this.activity = data.activity;
    this.notice = data.notice;
    this.appointments.future = data.appointments.future;
  },

  getUnreadTalkOnlyMatching(): string {
    return this.chat_rooms.matched;
  },

  getUnreadTalkOnlyContacting(): string {
    return this.chat_rooms.contacted;
  },

  getUnreadTalkOfMatchingAndContacting(): string {
    return this.chat_rooms.matched + this.chat_rooms.contacted;
  },

  getUnreadTalkNumOnlyGood(): string {
    return this.chat_rooms.liked;
  },

  getUnreadNoticeNumAll(): string {
    return this.notice + this.activity;
  },

  getUnreadNoticeNum(): string {
    return this.notice;
  },

  getUnreadActivityNum(): string {
    return this.activity;
  },

  getFutureAppointmentNum(): string {
    return this.appointments.future;
  },
};



// WEBPACK FOOTER //
// ./src/models/unread-num.ts